<template>
  <div>
    <a-button type="primary" @click="showModal" style="margin-left:50px" v-if="!onlyShow">添加</a-button>
    <a-table
      :columns="columns"
      :data-source="doctor_list"
      bordered
      style="margin:30px;"
      :pagination="false"
    >
      <template slot="operation" slot-scope="text, record, index" v-if="!onlyShow">
        <div class="editable-row-operations">
          <a @click="() => delete(record.key)">移出</a>
        </div>
      </template>
    </a-table>

    <a-modal
      v-if="!onlyShow"
      title="请选择"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-table
        :columns="columns_modal"
        :data-source="data_modal"
        :row-selection="rowSelection"
        bordered
        :pagination="false"
      ></a-table>
    </a-modal>
  </div>
</template>

<script>
import request from "@/utils/request";

const columns_modal = [
  {
    title: "姓名",
    dataIndex: "name",
    width: "40%"
  },
  {
    title: "手机号",
    dataIndex: "phone",
    width: "40%"
  }
];

export default {
  name: "ProjectAddDoctor",
  props: {
    doctor_list: Array,
    onlyShow: Boolean
  },
  data() {
    const columns = [
      {
        title: "姓名",
        dataIndex: "name",
        width: "15%"
      },
      {
        title: "手机号",
        dataIndex: "phone",
        width: "15%"
      },
      {
        title: "身份证",
        dataIndex: "id_code",
        width: "15%"
      },
      {
        title: "是否激活",
        dataIndex: "review",
        width: "7%"
      }
    ];
    if (!this.onlyShow) {
      columns.push({
        title: "操作",
        width: "30%",
        dataIndex: "operation",
        scopedSlots: { customRender: "operation" }
      });
    }
    console.log("columns,this.onlyShow", this.onlyShow, columns);
    return {
      visible: false,
      confirmLoading: false,
      columns,
      columns_modal,
      data_modal: [],
      selectedRowKeys: this.doctor_list.map(item=>{
        return item.id
      })
    };
  },
  mounted() {
    this.getDoctorList();
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        selectedRowKeys,
        hideDefaultSelections: true,
        onChange: this.onSelectChange,
        onSelection: this.onSelection
      };
    }
  },
  methods: {
    getDoctorList() {
      request({
        url: "/doctor/all_no_page",
        method: "get",
        params: {}
      }).then(response => {
        let data = response.data;
        if (data.success) {
          //   this.data = data.data;
          this.data_modal = data.data;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
    delete(item) {},
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      this.confirmLoading = true;
      console.log("selectedRowKeys", this.selectedRowKeys);
      let doctor_list = this.data_modal.filter(item => {
        return this.selectedRowKeys.indexOf(item.key) != -1;
      });
      this.confirmLoading = false;
      this.visible = false;
      this.doctor_list=doctor_list;
      this.$emit("updateDoctor", doctor_list);
    },
    handleCancel(e) {
      console.log("Clicked cancel button");
      this.visible = false;
    },
    onSelectChange(selectedRowKeys) {
      console.log("selectedRowKeys changed: ", selectedRowKeys);
      this.selectedRowKeys = selectedRowKeys;
    }
  }
};
</script>

<style>
</style>